import { CheckMarkIconTwoTone, CloseIcon } from '@room-match/shared-ui-components';
import React, { useEffect } from 'react';
import { FlexContainer, TypographyContainer } from './NotificationText.styles';

type Props = {
  type?: string;
  duration?: number;
  label?: string;
  show: boolean;
  setShow: (show: boolean) => void;
  gap?: number;
};

const NotificationText: React.FC<Props> = ({
  type = 'success',
  duration = 10000,
  label,
  show = false,
  setShow,
  gap = 5,
}) => {
  useEffect(() => {
    const timeId = setTimeout(() => {
      setShow(false);
    }, duration);

    return () => {
      clearTimeout(timeId);
    };
  }, [duration, setShow]);

  return (
    <TypographyContainer fontSize={13} $visible={show}>
      {type === 'success' ? (
        <FlexContainer $gap={gap} $type={type}>
          <CheckMarkIconTwoTone style={{ width: 16 }} />
          {label ? label : 'Successfully Updated'}
        </FlexContainer>
      ) : (
        <FlexContainer $gap={gap} $type={type}>
          <CloseIcon style={{ width: 13 }} />
          {label ? label : 'Unsuccessful. Something went wrong.'}
        </FlexContainer>
      )}
    </TypographyContainer>
  );
};

export default NotificationText;
